import { Layout } from 'antd'
import { useTheme } from 'antd-style'
import { PropsWithChildren } from 'react'

import { Text } from 'src/components'

import { useStyles } from './styles'

export const Footer = ({ children }: PropsWithChildren) => {
  const { styles } = useStyles()
  const { grey } = useTheme()

  return (
    <Layout.Footer className={styles.footer}>
      <Text size="lg" color={grey.grey1}>
        {children}
      </Text>
    </Layout.Footer>
  )
}
